import { render, staticRenderFns } from "./EditEnquiry.vue?vue&type=template&id=e6bc788c&"
import script from "./EditEnquiry.vue?vue&type=script&lang=js&"
export * from "./EditEnquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports